<div id="section-feature">
  <div class="linear-diagonal"></div>
  <div class="container">
    <div class="row">
      @for (item of items; track item) {
        <div class="col-6 col-md-3 text-center">
          <div class="icon">
            <fa-icon [icon]="item.icon"></fa-icon>
          </div>
          <h3>{{ item.titleKey | translate }}</h3>
        </div>
      }
    </div>
  </div>
  <div class="linear-diagonal-b"></div>
</div>
